<template>
    <div class="language-edit form-material" v-if="record">
      <h2>{{ isNewRecord ? 'Create Record' : 'Edit Record' }}</h2>
      <div class="row">
        <div class="form-group row">
          <div class="col-2">
            <label for="reference">Reference</label>
            <input type="text" class="form-control" id="reference" v-model="record.Reference" required>
          </div>
          <div class="col-3">
            <label for="toCurrency">To Currency</label>
            <select class="form-control" id="toCurrency" v-model="record.ToCurrency" required>
              <option v-for="currency in currencys" :key="currency" :value="currency">
                {{ currency }}
              </option>
            </select>
          </div>
          <div class="col-2">
            <label for="convertValue">Convert Value</label>
            <input type="number" class="form-control" id="convertValue" v-model="record.ConvertValue" required>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="btn-group" role="group">
            <button type="submit" class="btn btn-primary" @click="handleSave" :disabled="!record.FromCurrency || !record.ToCurrency || !record.ConvertValue ">Save</button>
            <button type="button" class="btn btn-danger" @click="deleteRecord" v-if="!isNewRecord">Delete</button>
            <button type="button" class="btn btn-secondary" @click="cancel">Exit</button>
          </div>
        </div>
      </div>
    </div>
    
  </template>
  
  <script>
  import RecordMixin from '@/components/tools/RecordMixin.vue';
  export default {
    name: 'BookingCCEdit',
    mixins: [RecordMixin],
    props: ['id'],
    data() {
      return {
        table: 'bookingcc',
        isUploading: false,
        refCodeTimeout: null,
      };
    },
    async created () {
      this.ready = false;
      if (this.id) {
        await this.fetchRecord();
      }
      this.ready = true;
    },
    methods: {
      async handleSave(event) {
        this.$store.commit('setProcessing', true);
        try {
          await this.saveRecord(event);
        } catch (error) {
          this.$root.$refs.index.showNotification(`Error al guardar: ${error}`, 'danger');
        } finally {
          this.$store.commit('setProcessing', false);
        }
      },
    },
    computed: {
      currencys() {
        return this.$store.state.currencys;
      }
    }
  }
</script>

  
  <style scoped>
  .language-edit {
    margin: 0 auto;
    padding: 20px;
  }
  h3 {
    color: #2c3e50;
    margin-bottom: 15px;
  }
  h4 {
    color: #2c3e50;
    margin-bottom: 12px;
  }
  </style>